/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { sum, map, filter, uniqBy } from 'lodash';
import { store, dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { Parent } from '../../@types/parent';
import {
  getUserReport,
  getStudentResReport,
  getUserReportCount,
  getStudentReportCount
} from '../../api/parent';

// ----------------------------------------------------------------------

const initialState: Parent = {
  isLoading: false,
  limit: process.env.REACT_APP_TABLE_PER_PAGE || 10,
  offset: 0,
  total: 0,
  error: false,
  task_name: '',
  secondList: [],
  secondLimit: process.env.REACT_APP_TABLE_PER_PAGE || 10,
  secondOffset: 0,
  parentChildTaskList: [],
  gradeList: [],
  searchClassId: [],
  viewSearchClassId: [],
  reportCountList: [],
  parentChildNumbers: [],
  editInfo: null,
  adapterType: '',
  publishStatus: ''
};

const slice = createSlice({
  name: 'parent',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setLimit(state, { payload }) {
      state.limit = payload;
    },
    setOffset(state, { payload }) {
      state.offset = payload;
    },
    getParentChildTaskList(state, { payload }) {
      state.isLoading = false;
      const { total, rows } = payload;
      state.parentChildTaskList = rows;
      state.total = total;
    },
    getTaskName(state, { payload }) {
      state.task_name = payload;
    },

    clearSecondList(state) {
      state.isLoading = false;
      state.secondList = [];
    },
    getSecondList(state, { payload }) {
      state.isLoading = false;
      state.secondList = payload;
    },
    getSearchClassId(state, { payload }) {
      state.searchClassId = payload;
    },
    getViewSearchClassId(state, { payload }) {
      state.viewSearchClassId = payload;
    },
    setSecondLimit(state, { payload }) {
      state.secondLimit = payload;
    },
    setSecondOffset(state, { payload }) {
      state.secondOffset = payload;
    },
    getReportCountList(state, { payload }) {
      state.reportCountList = payload;
    },
    getParentChildNumbers(state, { payload }) {
      state.parentChildNumbers = payload;
    },
    getEditInfo(state, { payload }) {
      state.editInfo = payload;
    },
    getAdapterType(state, { payload }) {
      state.adapterType = payload;
    },
    setPublishStatus(state, { payload }) {
      state.publishStatus = payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getTaskName,
  setLimit,
  setOffset,
  setSecondLimit,
  setSecondOffset,
  getSearchClassId,
  getViewSearchClassId,
  getEditInfo,
  getAdapterType,
  setPublishStatus
} = slice.actions;

// ----------------------------------------------------------------------

// 親子任務list
export function fetchParentChildTaskList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getStudentResReport(params);

      dispatch(slice.actions.getParentChildTaskList(response));
    } catch (error) {
      console.error(error);
    }
  };
}

// 獲取list
export function getSecondListAction(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getUserReport(params);

      const data = response.all !== 0 ? response.rows : [];
      dispatch(slice.actions.getSecondList(data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.clearSecondList());
    }
  };
}

// reportCountList
export function fetchReportCountList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getUserReportCount(params);

      dispatch(slice.actions.getReportCountList(response));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.clearSecondList());
    }
  };
}

export function fetchParentChildNumbers(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getStudentReportCount(params);

      dispatch(slice.actions.getParentChildNumbers(response));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.clearSecondList());
    }
  };
}
